module.exports = __webpack_public_path__ + "img/已完成延期.12552842.svg";